<template>
  <div>
    <a-modal
      v-model="open"
      :title="$t('sabbatical.label_title_update')"
      :centered="true"
      :footer="null"
      :width="684"
      :zIndex="1030"
      class="sabbatical-request-modal"
      :destroyOnClose="true"
    >
      <ValidationObserver
        ref="formSabbaticalEmployee"
        v-slot="{ handleSubmit }"
      >
        <!-- <CRow> -->
        <!-- <CCol :md="{ size: '10', offset: '2' }" class="sabbatical-leave"> -->
        <CCard>
          <CCardHeader>
            <!-- <label class="title-header">{{
                $t("sabbatical.label_title")
              }}</label>
              <br /><br /> -->
            <label>{{ $t("commons.note") }}</label>
            <p class="note">
              {{ $t("sabbatical.choose_time", { 
                morning_shift_start: account.work_shift.morning_shift_start.slice(0, 5), 
                morning_shift_end: account.work_shift.morning_shift_end.slice(0, 5), 
                afternoon_shift_start: account.work_shift.afternoon_shift_start.slice(0, 5), 
                afternoon_shift_end: account.work_shift.afternoon_shift_end.slice(0, 5) 
              }) }}
            </p>
            <p class="note">
              {{ $t("sabbatical.time_real") }}
              {{ dataCommons.all_time_days_off_sabbatical_rest_real }}
            </p>
            <p class="note-link note" @click="linkToGuide()">
              {{ $t("commons.regulations_of_the_company_on_leave_here") }}
            </p>
          </CCardHeader>
          <CCardBody>
            <CForm
              class="create_form"
              @submit.prevent="handleSubmit(createSabbaticalRequest)"
            >
              <CRow>
                <CCol md="6" class="form-field">
                  <label>
                    {{ $t("employee.label_employee_code") }}
                  </label>
                  <CInput
                    type="text"
                    :disabled="true"
                    v-model="dataCommons.id"
                  />
                </CCol>

                <CCol md="6" class="form-field mobile-input">
                  <label>
                    {{ $t("employee.label_employee_name") }}
                  </label>
                  <CInput
                    type="text"
                    :disabled="true"
                    v-model="dataCommons.name"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol md="6" class="form-field">
                  <label>
                    {{ $t("employee.label_employee_foot") }}
                  </label>
                  <CInput
                    type="text"
                    :disabled="true"
                    v-model="dataCommons.foot"
                  />
                </CCol>

                <CCol md="6" class="form-field mobile-input">
                  <label>
                    {{ $t("employee.label_employee_division") }}
                  </label>
                  <CInput
                    type="text"
                    :disabled="true"
                    v-model="dataCommons.division"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol md="6" class="form-field">
                  <label>
                    {{ $t("commons.label_approve_person1") }}
                    <span class="require">*</span>
                  </label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="overtime.approve"
                  >
                    <select
                      class="form-control"
                      v-model="forms.approve_person_1"
                    >
                      <option
                        v-for="(option, index) in approveEmployees['level1']"
                        :key="index"
                        :value="option.id"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                    <span class="required">{{ errors[0] }}</span>
                  </ValidationProvider>
                </CCol>

                <CCol
                  md="6"
                  class="form-field mobile-input"
                  v-if="
                    approveEmployees['level2'] &&
                    approveEmployees['level2'].length > 0
                  "
                >
                  <label>
                    {{ $t("commons.label_approve_person2") }}
                    <span class="require">*</span>
                  </label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="overtime.approve2"
                  >
                    <select
                      class="form-control"
                      v-model="forms.approve_person_2"
                    >
                      <option
                        v-for="(option, index) in approveEmployees['level2']"
                        :key="index"
                        :value="option.id"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                    <span class="required">{{ errors[0] }}</span>
                  </ValidationProvider>
                </CCol>
              </CRow>
              <CRow>
                <CCol md="6" class="form-field">
                  <label>
                    {{ $t("sabbatical.reason") }}
                    <span class="require">*</span>
                  </label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="sabbatical.reason"
                  >
                    <select class="form-control" v-model="forms.reason_code">
                      <option value="">
                        {{ $t("employee.select_option") }}
                      </option>
                      <option
                        v-for="(option, index) in reasons"
                        :key="index"
                        :value="option.code"
                      >
                        {{ option.reason }}
                      </option>
                    </select>
                    <span class="required">{{ errors[0] }}</span>
                  </ValidationProvider>
                </CCol>

                <CCol md="6" class="form-field mobile-input">
                  <label>
                    {{ $t("sabbatical.type_reason") }}
                    <span class="require">*</span>
                  </label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="sabbatical.type_reason"
                  >
                    <select class="form-control" v-model="forms.reason_type">
                      <option value="">
                        {{ $t("employee.select_option") }}
                      </option>
                      <option value="1">
                        {{ $t("sabbatical.type_reason_1") }}
                      </option>
                      <option value="2">
                        {{ $t("sabbatical.type_reason_2") }}
                      </option>
                      <option value="3">
                        {{ $t("sabbatical.type_reason_3") }}
                      </option>
                    </select>
                    <span class="required">{{ errors[0] }}</span>
                  </ValidationProvider>
                </CCol>
              </CRow>
              <CRow>
                <CCol md="6" class="form-field">
                  <label>
                    {{ $t("label.start_time") }}
                    <span class="require">*</span>
                  </label>
                  <ValidationProvider
                    :rules="{
                      required: true,
                      regex: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
                      between_time_start_time: account.work_shift.morning_shift_start.slice(0, 5),
                      less_end_time: {
                        start_date: forms.start_date.format('DD/MM/YYYY'),
                        end_date: forms.end_date.format('DD/MM/YYYY'),
                        end_time: forms.end_time,
                      },
                      start_time_is_not_fit: true,
                    }"
                    v-slot="{ errors }"
                    name="sabbatical.start_time"
                  >
                    <b-form-input
                      type="text"
                      v-mask="'##:##'"
                      placeholder="HH:mm"
                      v-model="forms.start_time"
                      v-on:keyup="calculateDaySabbatical"
                    />
                    <span class="required">{{ errors[0] }}</span>
                  </ValidationProvider>
                </CCol>
                <CCol md="6" class="form-field mobile-input">
                  <label>
                    {{ $t("commons.label_start_date") }}
                    <span class="require">*</span>
                  </label>
                  <div>
                    <ValidationProvider
                      :rules="{
                        required: true,
                      }"
                      v-slot="{ errors }"
                      name="sabbatical.label_start_date"
                    >
                      <a-date-picker
                        dropdownClassName="dropdownDatePicker"
                        :disabled-date="disabledStartDate"
                        format="DD/MM/YYYY"
                        v-model="forms.start_date"
                        :placeholder="$t('overtime.date')"
                        @change="startDate"
                      />
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <!-- <DatePickerForm
                    :propsDate="forms.start_date ? forms.start_date : ''"
                    v-on:emitDate="startDate"
                    :rules="{
                      required_date: true,
                      regex:
                        /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/,
                      between_time_start_date: forms.end_date,
                    }"
                    :name="'fields.sabbatical.label_start_date'"
                  /> -->
                </CCol>
              </CRow>
              <CRow>
                <CCol md="6" class="form-field">
                  <label>
                    {{ $t("label.end_time") }}
                    <span class="require">*</span>
                  </label>
                  <ValidationProvider
                    :rules="{
                      required: true,
                      regex: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
                      between_time_end_time: account.work_shift.afternoon_shift_end.slice(0, 5),
                      fewer_start_time: {
                        start_time: forms.start_time,
                        start_date: forms.start_date.format('DD/MM/YYYY'),
                        end_date: forms.end_date.format('DD/MM/YYYY'),
                      },
                      end_time_is_not_fit: true,
                    }"
                    v-slot="{ errors }"
                    name="sabbatical.end_time"
                  >
                    <b-form-input
                      type="text"
                      v-mask="'##:##'"
                      placeholder="HH:mm"
                      v-model="forms.end_time"
                      v-on:keyup="calculateDaySabbatical"
                    />
                    <span class="required">{{ errors[0] }}</span>
                  </ValidationProvider>
                </CCol>
                <CCol md="6" class="form-field mobile-input">
                  <label>
                    {{ $t("commons.label_end_date") }}
                    <span class="require">*</span>
                  </label>
                  <div>
                    <ValidationProvider
                      :rules="{
                        required: true,
                      }"
                      v-slot="{ errors }"
                      name="sabbatical.label_end_date"
                    >
                      <a-date-picker
                        dropdownClassName="dropdownDatePicker"
                        :disabled-date="disabledEndDate"
                        format="DD/MM/YYYY"
                        v-model="forms.end_date"
                        :placeholder="$t('overtime.date')"
                        @change="endDate"
                      />
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <!-- <DatePickerForm
                    :propsDate="forms.end_date ? forms.end_date : ''"
                    v-on:emitDate="endDate"
                    :rules="{
                      required_date: true,
                      regex:
                        /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/,
                      between_time_end_date: forms.start_date,
                    }"
                    :name="'fields.sabbatical.label_end_date'"
                  /> -->
                </CCol>
              </CRow>
              <CRow>
                <CCol md="4" class="form-field">
                  <label>
                    {{ $t("sabbatical.number_days_off") }}
                    <span class="require">*</span>
                  </label>
                  <ValidationProvider
                    :rules="{
                      required: true,
                      min_value: 0.5,
                      less_number_of_days_off_rest: {
                        reason_type: forms.reason_type,
                        number_of_days_off_rest:
                          dataCommons.number_of_days_off_rest,
                      },
                    }"
                    ref="numberDaysOff"
                    v-slot="{ errors }"
                    name="sabbatical.number_days_off"
                  >
                    <CInput
                      type="text"
                      v-model="forms.number_days_off"
                      :disabled="true"
                    />
                    <span class="required">{{ errors[0] }}</span>
                    <br />
                    <span
                      class="required custom"
                      v-if="
                        forms.number_days_off >
                          dataCommons.all_time_days_off_sabbatical_rest_real &&
                        forms.reason_type === '1'
                      "
                      >{{ $t("sabbatical.time_real") }}
                      {{
                        dataCommons.all_time_days_off_sabbatical_rest_real
                      }}</span
                    >
                  </ValidationProvider>
                </CCol>

                <CCol md="4" class="form-field">
                  <label>
                    {{ $t("sabbatical.number_of_days_off") }}
                  </label>
                  <CInput
                    type="text"
                    :disabled="true"
                    v-model="dataCommons.number_of_days_off"
                  />
                </CCol>
                <CCol md="4" class="form-field mobile-input">
                  <label>
                    {{ $t("sabbatical.number_of_days_off_rest") }}
                  </label>
                  <CInput
                    type="text"
                    :disabled="true"
                    v-model="dataCommons.number_of_days_off_rest"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol md="12" class="form-field">
                  <label>
                    {{ $t("sabbatical.note") }}
                    <span class="require">*</span>
                  </label>
                  <ValidationProvider
                    rules="required|max:512"
                    v-slot="{ errors }"
                    name="sabbatical.note"
                  >
                    <b-form-textarea
                      id="textarea"
                      rows="4"
                      max-rows="6"
                      v-model="forms.note"
                    ></b-form-textarea>
                    <span class="required">{{ errors[0] }}</span>
                  </ValidationProvider>
                </CCol>
              </CRow>
              <CRow>
                <CCol md="12" class="employees-form-sabbatical">
                  <CButton type="submit" class="save-info footer-btn"
                    >{{ $t("label.save_infomation") }}
                  </CButton>
                  <CButton
                    class="cancel-btn footer-btn"
                    type="button"
                    @click="cancel()"
                    >{{ $t("popup.label_cancel_button") }}
                  </CButton>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
        <!-- </CRow> -->
      </ValidationObserver>
    </a-modal>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import "sweetalert2/src/sweetalert2.scss";
import moment from "moment";
import _ from "lodash";
// import DatePickerForm from "@/components/commons/DatePickerForm";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    // DatePickerForm,
  },
  computed: {
    ...mapGetters({
      dataCommons: "sabbatical-leave-request/dataCommons",
      reasons: "sabbatical-leave-request/reasons",
      approveEmployees: "commons/approvalPersonList",
      employeeSabbaticalInfo: "sabbatical-leave-request/employeeSabbaticalInfo",
      timeWeekend: "sabbatical-leave-request/timeWeekend",
      account: "auth/account",
    }),
  },
  data() {
    return {
      time_8_h: 8, // 8H00
      time_12_h: 12, // 12H00
      time_13_h_30_m: 13.5, // 13H30
      time_17_h_30_m: 17.5, // 17H30
      time_1_h_30m: 1.5, // 1H30
      working_time_of_day: 8,
      forms: {
        sabbatical_request_id: "",
        approve_person_1: null,
        approve_person_2: null,
        reason_code: "",
        reason_type: "",
        start_time: "08:00",
        end_time: "17:30",
        start_date: moment(),
        end_date: moment(),
        number_days_off: 1,
        note: null,
        numberDaysOffRest: null,
        allTimeDaysOffSabbatical: null,
        number_of_days_leave: null,
      },
      open: false,
      isScrollModal: true,
    };
  },

  methods: {
    ...mapActions("layout", ["setLoading"]),
    startDate(data) {
      this.forms.start_date = data;
      this.calculateDaySabbatical();
    },
    endDate(data) {
      this.forms.end_date = data;
      this.calculateDaySabbatical();
    },
    async createSabbaticalRequest() {
      if (
        this.forms.number_days_off >
          this.dataCommons.all_time_days_off_sabbatical_rest_real &&
        this.forms.reason_type === "1"
      ) {
        return false;
      }
      this.$root.$loading.start();
      this.forms.numberDaysOffRest = this.dataCommons.number_of_days_off_rest;
      this.forms.number_of_days_leave = this.dataCommons.number_of_days_leave;
      this.forms.allTimeDaysOffSabbaticalRest =
        this.dataCommons.all_time_days_off_sabbatical_rest * 1 +
        this.forms.number_days_off * 1;
      const formData = {
        ...this.forms,
        start_date: this.forms.start_date.format("DD/MM/YYYY"),
        end_date: this.forms.end_date.format("DD/MM/YYYY"),
      };
      await this.$store
        .dispatch("sabbatical-leave-request/updateSabbaticalRequest", formData)
        .then(() => {
          let message = this.$t("sabbatical.message_create_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          // this.$emit("fetchTotalRequest");
          this.$emit("fetchSabbticalRequestList");
          this.resetForm();
          this.open = false;
          // this.$router.push({ path: "/sabbatical-leave-request" });
          this.$root.$loading.finish();
        })
        .catch(() => {
          this.$root.$loading.finish();
        });
    },
    async show(id) {
      this.$root.$loading.start();
      if (_.isEmpty(this.dataCommons)) {
        await this.$store.dispatch("sabbatical-leave-request/getDataCommons");
      }
      if (_.isEmpty(this.approveEmployees)) {
        await this.$store.dispatch("commons/getApprovePersonBySetting");
      }
      await this.getSabbaticalRequestById(id);
      this.initialData();
      this.open = true;
      this.forms.start_time = this.account.work_shift.morning_shift_start.slice(0, 5);
      this.forms.end_time =this.account.work_shift.afternoon_shift_end.slice(0, 5);
      this.time_8_h = this.timeToDecimal(this.account.work_shift.morning_shift_start);
      this.time_12_h = this.timeToDecimal(this.account.work_shift.morning_shift_end);
      this.time_13_h_30_m = this.timeToDecimal(this.account.work_shift.afternoon_shift_start);
      this.time_17_h_30_m = this.timeToDecimal(this.account.work_shift.afternoon_shift_end);
      this.time_1_h_30m = this.time_13_h_30_m - this.time_12_h;
      this.$root.$loading.finish();
    },

    cancel() {
      this.$confirmModal(
        this.$t("popup.employee.label_popup_title"),
        this.$t("popup.sabbatical.label_popup_title_update_cancel"),
        this.$t("popup.employee.label_confirm_button"),
        this.$t("popup.employee.label_cancel_button"),
        "danger"
      ).then((value) => {
        if (value) {
          this.resetForm();
          this.open = false;
        }
      });
    },

    async calculateDaySabbatical() {
      if (
        this.forms.start_date &&
        this.forms.end_date &&
        this.forms.start_time &&
        this.forms.end_time
      ) {
        let start_date_check = this.forms.start_date;
        let end_date_check = this.forms.end_date;
        let start_time_check = moment(this.forms.start_time, "HH:mm", true);
        let end_time_check = moment(this.forms.end_time, "HH:mm", true);
        if (
          start_date_check?.isValid() &&
          end_date_check?.isValid() &&
          start_time_check.isValid() &&
          end_time_check.isValid()
        ) {
          await this.$store.dispatch(
            "sabbatical-leave-request/getCalculateDayLeave",
            {
              end_time: this.forms.end_time,
              start_time: this.forms.start_time,
              start_date: this.forms.start_date.format("DD/MM/YYYY"),
              end_date: this.forms.end_date.format("DD/MM/YYYY"),
            }
          );
          let start_date = this.forms.start_date
            .format("DD/MM/YYYY")
            .split("/");
          let end_date = this.forms.end_date.format("DD/MM/YYYY").split("/");
          let start_time = this.forms.start_time.split(":");
          let end_time = this.forms.end_time.split(":");
          let hours_start_time = start_time[0] * 1 + start_time[1] / 60;
          let hours_end_time = end_time[0] * 1 + end_time[1] / 60;
          let startDate = new Date(
            start_date[2],
            start_date[1] - 1,
            start_date[0]
          ).getTime();
          let endDate = new Date(
            end_date[2],
            end_date[1] - 1,
            end_date[0]
          ).getTime();
          let sumDate = (endDate - startDate) / 86400000;
          if (this.forms.start_date === this.forms.end_date) {
            this.calculateDaySabbaticalInDay(hours_start_time, hours_end_time);
          } else {
            this.calculateDaySabbaticalDifferentDay(
              hours_start_time,
              hours_end_time,
              sumDate
            );
          }
        }
      } else {
        this.forms.number_days_off = 0;
      }
    },

    calculateDaySabbaticalInDay(hours_start_time, hours_end_time) {
      if (
        hours_start_time >= this.time_8_h &&
        hours_start_time <= this.time_12_h &&
        hours_end_time >= this.time_13_h_30_m &&
        hours_start_time <= this.time_17_h_30_m
      ) {
        this.forms.number_days_off =
          (this.time_12_h -
            hours_start_time +
            (hours_end_time - this.time_13_h_30_m)) /
          this.working_time_of_day;
      }

      if (
        (hours_start_time >= this.time_8_h &&
          hours_end_time <= this.time_12_h) ||
        (hours_start_time >= this.time_13_h_30_m &&
          hours_end_time <= this.time_17_h_30_m)
      ) {
        this.forms.number_days_off =
          (hours_end_time - hours_start_time) / this.working_time_of_day;
      }
      this.forms.number_days_off =
        Math.round(this.forms.number_days_off * 100) / 100 - this.timeWeekend;
      if (this.forms.number_days_off < 0) {
        this.forms.number_days_off = 0;
      }
      this.$nextTick(function () {
        this.$refs.numberDaysOff.validate();
      });
    },

    calculateDaySabbaticalDifferentDay(
      hours_start_time,
      hours_end_time,
      sumDate
    ) {
      if (
        hours_start_time >= this.time_8_h &&
        hours_start_time <= this.time_12_h &&
        hours_end_time >= this.time_13_h_30_m &&
        hours_end_time <= this.time_17_h_30_m
      ) {
        this.forms.number_days_off =
          sumDate -
          1 +
          (this.time_17_h_30_m -
            hours_start_time -
            this.time_1_h_30m +
            (hours_end_time - this.time_8_h - this.time_1_h_30m)) /
            this.working_time_of_day;
      }

      if (
        hours_end_time >= this.time_8_h &&
        hours_end_time <= this.time_12_h &&
        hours_start_time >= this.time_13_h_30_m &&
        hours_start_time <= this.time_17_h_30_m
      ) {
        this.forms.number_days_off =
          sumDate -
          1 +
          (this.time_17_h_30_m -
            hours_start_time +
            (hours_end_time - this.time_8_h)) /
            this.working_time_of_day;
      }

      if (
        hours_start_time >= this.time_8_h &&
        hours_start_time <= this.time_12_h &&
        hours_end_time >= this.time_8_h &&
        hours_end_time <= this.time_12_h
      ) {
        this.forms.number_days_off =
          sumDate -
          1 +
          (this.time_17_h_30_m -
            hours_start_time -
            this.time_1_h_30m +
            (hours_end_time - this.time_8_h)) /
            this.working_time_of_day;
      }

      if (
        hours_end_time >= this.time_13_h_30_m &&
        hours_end_time <= this.time_17_h_30_m &&
        hours_start_time >= this.time_13_h_30_m &&
        hours_start_time <= this.time_17_h_30_m
      ) {
        this.forms.number_days_off =
          sumDate -
          1 +
          (this.time_17_h_30_m -
            hours_start_time +
            (hours_end_time - this.time_8_h - this.time_1_h_30m)) /
            this.working_time_of_day;
      }
      this.forms.number_days_off =
        Math.round(this.forms.number_days_off * 100) / 100 - this.timeWeekend;
      if (this.forms.number_days_off < 0) {
        this.forms.number_days_off = 0;
      }
      this.$nextTick(function () {
        this.$refs.numberDaysOff.validate();
      });
    },

    linkToGuide() {
      this.$store.dispatch("commons/setLeaveValue");
      this.$router.push({ path: "/note/document" });
    },
    disabledStartDate(current) {
      if (this.forms.end_date) {
        return current > this.forms.end_date;
      }
    },
    disabledEndDate(current) {
      if (this.forms.start_date) {
        return current < this.forms.start_date;
      }
    },
    async getSabbaticalRequestById(id) {
      await this.$store.dispatch(
        "sabbatical-leave-request/getInfoSabbatical",
        id
      );
    },
    initialData() {
      let requestData = {
        ...this.employeeSabbaticalInfo,
        end_date: moment(this.employeeSabbaticalInfo.end_date, "DD/MM/YYYY"),
        start_date: moment(
          this.employeeSabbaticalInfo.start_date,
          "DD/MM/YYYY"
        ),
      };
      this.forms = { ...requestData };
    },
    resetForm() {
      this.forms.sabbatical_request_id = "";
      this.forms.reason_code = "";
      this.forms.reason_type = "";
      this.forms.start_time = "08:00";
      this.forms.end_time = "17:30";
      this.forms.start_date = moment();
      this.forms.end_date = moment();
      this.forms.number_days_off = 1;
      this.forms.note = null;
      this.forms.numberDaysOffRest = null;
      this.forms.allTimeDaysOffSabbatical = null;
      this.forms.number_of_days_leave = null;
    },
    timeToDecimal(time) {
      const [hour, minute] = time.split(':').map(Number);
      return hour + minute / 60;
    }
  },
};
</script>

<style lang="scss" scoped>
.save-info {
  margin-right: 10px;
  background-color: #3d4cdc;
  color: #fff;
}
.footer-btn {
  border-radius: 10px;
  width: 210px;
  height: 40px;
  font-weight: 700;
  font-size: 14px;
}

label {
  font-weight: 600;
}

.input-group {
  margin-bottom: 0px !important;
}

.row {
  margin-bottom: 20px;
}

.cancel-btn {
  padding: 7px 45px;
  font-weight: 600;
  background-color: #ececec;
  color: #6f6f6f;
}

span.require {
  color: #ff1a1a;
}

span.required {
  color: #ff1a1a;
  margin-top: -15px;
}

.form-group {
  margin-bottom: 0px;
}

.employees-form-sabbatical {
  text-align: center;
  margin-top: 15px;
}

// .sabbatical-leave {
//   margin: auto !important;
// }

p.note {
  font-weight: 700;
  color: #ff1a1a;
}
.note-link {
  cursor: pointer;
}
.dropdownDatePicker {
  z-index: 1031;
}
</style>

<style lang="scss">
.sabbatical-request-modal {
  .ant-modal-mask,
  .ant-modal-wrap {
    z-index: 1030;
  }
  .ant-modal {
    width: 100% !important;
    max-width: 684px;
  }
  .ant-modal-content {
    border-radius: 10px;
    overflow: hidden;
  }
  .ant-modal-header {
    background-color: #d2d6ff;
    border-bottom-color: #3d4cdc;
    .ant-modal-title {
      color: #3d4cdc;
    }
  }
  .ant-modal-body {
    max-height: 85vh;
    overflow-y: auto;
  }
  .ant-modal-close {
    outline: unset !important;
  }
  .ant-calendar-picker {
    width: 100%;
  }
  .ant-modal-close-x {
    line-height: 48px;
    outline: unset !important;
  }
}
</style>